function trustpilotLambdaFunction() {
  const apiUrl =
    "https://j6gdtfh0u2.execute-api.eu-north-1.amazonaws.com/default/clientTrustPilotData/trustpilot-data";

  const bannerContainer = document.querySelector(".trustpilotBannerContainer");
  if (!bannerContainer) return;

  const preconnectLink = document.createElement("link");
  preconnectLink.rel = "preconnect";
  preconnectLink.href =
    "https://j6gdtfh0u2.execute-api.eu-north-1.amazonaws.com";
  document.head.appendChild(preconnectLink);

  const createStarRatingElement = (() => {
    const template = document.createElement("div");
    template.classList.add("trustpilot-item__stars");
    const starImage = document.createElement("img");
    starImage.alt = "Star Rating";
    template.appendChild(starImage);
    return (starImageUrl) => {
      const element = template.cloneNode(true);
      element.querySelector("img").src = starImageUrl.startsWith("//")
        ? `https:${starImageUrl}`
        : starImageUrl;
      return element;
    };
  })();

  function customTrustpilotBanner(
    representationValue,
    starImageUrl,
    trustScore,
    totalReviewsCount,
    logoImageUrl
  ) {
    const bannerElement = document.createElement("a");
    bannerElement.className =
      "custom-trustpilot-banner custom-trustpilot-banner--new";
    bannerElement.href = "https://uk.trustpilot.com/review/operabeds.com";
    bannerElement.target = "_blank";
    bannerElement.title = "Read all our TrustPilot Reviews";
    bannerElement.rel = "noopener";

    bannerElement.innerHTML = `
      <div class="ctb-row-1">
        <p>Our customers say <b>${representationValue}</b></p>
        <img src="${starImageUrl}" alt="Trustpilot Star Rating" width="100" height="20" />
      </div>
      <div class="ctb-row-2">
        <p><b>${trustScore}</b> out of 5 based on ${totalReviewsCount.toLocaleString()} Reviews</p>
        <img src="${logoImageUrl}" alt="Trustpilot Logo" width="192" height="47" />
      </div>`;

    bannerContainer.innerHTML = "";
    bannerContainer.appendChild(bannerElement);
  }

  function processReviews(reviews, container) {
    const fragment = document.createDocumentFragment();
    reviews.forEach((review) => {
      if (
        review.stars >= 4 &&
        review.stars <= 5 &&
        review.text.length >= 125 &&
        review.text.length <= 300
      ) {
        const slideElement = document.createElement("div");
        slideElement.classList.add("swiper-slide");
        slideElement.innerHTML = `
          <div class="cs-review-item">
            <div class="cs-review-item__stars">
              <img src="${review.starImageUrl}" alt="Star Rating">
            </div>
            <div class="cs-review-item__title">${review.title}</div>
            <div class="cs-review-item__review">${review.text}</div>
            <span class="cs-review-item__author">${
              review.consumer.displayName
            }</span>, 
            <span class="cs-review-item__date">${formatDate(
              review.createdAt
            )}</span>
          </div>`;
        fragment.appendChild(slideElement);
      }
    });
    container.appendChild(fragment);
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const suffix =
      day >= 11 && day <= 13
        ? "th"
        : ["th", "st", "nd", "rd"][day % 10] || "th";
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${day}${suffix} ${
      monthNames[date.getMonth()]
    } ${date.getFullYear()}`;
  }

  fetch(apiUrl)
    .then((response) => response.json())
    .then((data) => {
      if (!data || !data.reviews?.length) return;

      customTrustpilotBanner(
        data.starStringRepresentation,
        data.starImageUrl,
        data.trustScore,
        data.totalReviews,
        data.logoImageUrl
      );

      const reviewsContainer = document.getElementById("reviews-container");
      if (reviewsContainer) {
        processReviews(data.reviews, reviewsContainer);

        new Swiper(".tpReviewsSwiper", {
          slidesPerView: 1.1,
          spaceBetween: 8,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
          },
          breakpoints: {
            820: { slidesPerView: 2.5, spaceBetween: 8 },
            1280: { slidesPerView: 2.5, spaceBetween: 16 },
            1536: { slidesPerView: 3.1, spaceBetween: 16 },
            1920: { slidesPerView: 3.5, spaceBetween: 16 },
            3840: { slidesPerView: 5.5, spaceBetween: 16 },
          },
          keyboard: true,
        });
      }
    })
    .catch((error) => console.error("Error fetching Trustpilot data:", error));
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", trustpilotLambdaFunction);
} else {
  trustpilotLambdaFunction();
}
